import { useEffect, useState } from 'react';

export function useStateLocalStorage<StateType>(
    initState: StateType,
    localStorageKey: string
): [StateType, React.Dispatch<React.SetStateAction<StateType>>] {
    const [state, setState] = useState(getLocalStorageValue<StateType>(localStorageKey) ?? initState);

    useEffect(() => {
        const value = getLocalStorageValue<StateType>(localStorageKey);
        if (value === null) return;
        setState(value);
    }, [localStorageKey]);

    useEffect(() => {
        try {
            const valueToSave = JSON.stringify({ state });
            window.localStorage.setItem(localStorageKey, valueToSave);
        } catch (err) {console.error(err);}
    }, [state, localStorageKey]);

    return [state, setState];
}

function getLocalStorageValue<T>(localStorageKey: string): T | null {
    if (typeof window === 'undefined') return;
    const lsValue = window.localStorage.getItem(localStorageKey);
    try {
        if (lsValue === undefined || lsValue === null) return null;
        const parsedValue: { state: T } = JSON.parse(lsValue);
        return parsedValue.state;
    } catch (err) {console.error(err);}

    return null;
}
